import React, { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

import {
  StyledContainer,
  StyledElementWrapper,
  StyledElement
} from './Wizard.styles'

export const WizardElement = ({
  value,
  active,
  label,
  enabled,
  onChange,
  isLast,
  indexDiff,
  dataAttribute
}) => {
  const el = useRef(null)
  const [tooltip, setTooltip] = useState(undefined)
  const handleClick = () => {
    typeof onChange === 'function' && enabled && onChange(value)
  }

  useEffect(() => {
    if (el.current.offsetWidth < el.current.scrollWidth) {
      setTooltip(label)
    } else {
      setTooltip(undefined)
    }
  }, [label])

  useEffect(() => {
    ReactTooltip.rebuild()
  }, [tooltip])

  const separatorType = !isLast
    ? indexDiff === 0
      ? 'dark|light'
      : indexDiff === -1
        ? 'light|dark'
        : 'light|light'
    : undefined

  return (
    <StyledElementWrapper
      active={active}
      enabled={enabled}
      onClick={handleClick}
      separatorType={separatorType}
      data-mu-test={dataAttribute}
    >
      <StyledElement ref={el} data-tip={tooltip}>
        {label}
      </StyledElement>
    </StyledElementWrapper>
  )
}

export const Wizard = ({ className, value, options, onChange }) => {
  const activeIndex = options.findIndex(
    ({ value: optionValue, enabled }) => enabled && value === optionValue
  )

  return (
    <StyledContainer>
      {options.map(({ value: itemValue, label, enabled }, i) => (
        <WizardElement
          key={`wizard-${itemValue}-${i}`}
          value={itemValue}
          label={label}
          active={value === itemValue}
          enabled={enabled}
          onChange={onChange}
          isLast={options.length - 1 === i}
          indexDiff={i - activeIndex}
          dataAttribute={`e-wizard-element e-wizard-element-${i + 1}`}
        />
      ))}
    </StyledContainer>
  )
}

Wizard.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.node,
      enabled: PropTypes.bool
    })
  ),
  onChange: PropTypes.func
}

WizardElement.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  active: PropTypes.bool,
  label: PropTypes.node,
  enabled: PropTypes.bool,
  onChange: PropTypes.func,
  isLast: PropTypes.bool,
  indexDiff: PropTypes.number,
  dataAttribute: PropTypes.string
}
